"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Button_1 = require("@Components/Buttons/Button");
const navigation_1 = __importDefault(require("@App/navigation"));
require("./index.scss");
const SongwriterCatalogEmptyWarning = ({ currentSongwriterId }) => (react_1.default.createElement("div", { className: 'songwriter-empty-catalog' },
    react_1.default.createElement("p", null,
        react_1.default.createElement("strong", null, "You have nothing here")),
    react_1.default.createElement("p", null, "Get started now by searching The MLC database to find your works (songs)."),
    react_1.default.createElement(Button_1.Button, { mainColor: true, typeLink: true, type: 'primary', linkTo: navigation_1.default.songwriter.catalogBuilder(currentSongwriterId) }, "Build Your Catalog")));
exports.default = SongwriterCatalogEmptyWarning;
